import { defineComponent as _defineComponent } from 'vue';
import { watch } from 'vue';
import { MenuRoot, MenuTrigger, MenuContent, MenuItem, MenuLabel } from 'Components/primitives/menu';
import { ConfigProvider } from 'reka-ui';
import { DEFAULT_CLOSE_DELAY, DEFAULT_OPEN_DELAY, useMenuOpenState } from './useMenuOpenState';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnMenu',
    props: {
        side: { type: null, required: false, default: 'bottom' },
        sideOffset: { type: Number, required: false, default: 4 },
        align: { type: null, required: false, default: 'start' },
        collisionPadding: { type: [Number, Object], required: false },
        sticky: { type: String, required: false },
        prioritizePosition: { type: Boolean, required: false },
        class: { type: [Boolean, null, String, Object, Array], required: false, skipCheck: true },
        label: { type: String, required: false },
        items: { type: Array, required: false },
        shouldKeepFocus: { type: Boolean, required: false },
        trigger: { type: String, required: false, default: 'click' },
        openDelay: { type: Number, required: false, default: DEFAULT_OPEN_DELAY },
        closeDelay: { type: Number, required: false, default: DEFAULT_CLOSE_DELAY }
    },
    emits: ['update:open'],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const { open, setOpen, shouldFocusOnOpen, onOpenChange, onCloseAutoFocus, onTriggerPointerDown, onTriggerPointerEnter, onTriggerPointerLeave, onContentPointerEnter, onContentPointerLeave, } = useMenuOpenState(props);
        const onOpenAutoFocus = (event) => {
            if (!shouldFocusOnOpen.value)
                event.preventDefault();
        };
        const emit = __emit;
        watch(open, (val) => emit('update:open', val));
        __expose({
            setOpen
        });
        const __returned__ = { props, open, setOpen, shouldFocusOnOpen, onOpenChange, onCloseAutoFocus, onTriggerPointerDown, onTriggerPointerEnter, onTriggerPointerLeave, onContentPointerEnter, onContentPointerLeave, onOpenAutoFocus, emit, get MenuRoot() { return MenuRoot; }, get MenuTrigger() { return MenuTrigger; }, get MenuContent() { return MenuContent; }, get MenuItem() { return MenuItem; }, get MenuLabel() { return MenuLabel; }, get ConfigProvider() { return ConfigProvider; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
